export default __webpack_public_path__ + "static/media/flechaEsq.868bd2e4.png";